import ActionType from '../ActionType'
import { Auth } from 'utils/Auth'
import { contactFieldsWithoutColorsSelector } from 'selectors'
import API_URL from 'utils/ApiUrl'
import AJV from 'ajv'

const service = 'contact'

export const getContacts = () => (dispatch, getState) => {
	dispatch({ type: ActionType.Contacts.GET_ALL_REQUEST })

	return Auth.currentSession()
		.then((session) => {
			const headerValue = `Bearer ${session.idToken.jwtToken}`

			return fetch(API_URL + '/contact', {
				mode: 'cors',
				headers: {
					authorization: headerValue,
				},
			})
				.then((res) =>
					res.json().then((data) => {
						if (!res.ok) {
							return { notOk: true, ...data }
						}
						return data
					}),
				)
				.then(
					(payload) =>
						payload && payload.notOk
							? dispatch({
								type: ActionType.Data.LIST_FAILURE,
								payload,
								entityType: 'contact',
								notOk: true,
							})
							: dispatch({
								type: ActionType.Contacts.GET_ALL_SUCCESS,
								payload,
							}),
					(error) =>
						dispatch({
							type: ActionType.Data.LIST_FAILURE,
							payload: error,
							entityType: 'contact',
						}),
				)
		})
		.catch((err) => {
			console.log(err)
			if (err.code === 'UserNotFoundException') {
				window.localStorage.clear()
				window.location.reload(true)
			}
		})
}

export const getContactWithoutDispatch = (id) => (dispatch, getState) =>
	new Promise((res, rej) => {
		if (id) {
			return Auth.currentSession()
        .then(session => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(`${API_URL}/contact/${id}`, {
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
              'content-type': 'application/json',
              authorization: headerValue,
            },
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
          })
            .then(res =>
              res.json().then(data => {
                if (!res.ok) {
                  return { notOk: true, ...data }
                }
                return data
              }),
            )
            .then(payload => {
              if (payload && payload.notOk) {
                console.log('contact read failure:', id)

                rej(payload)
                return
              }

              res(payload)
            })
            .catch(error => {
              rej(error)
            })
        })
        .catch(err => {
          console.log(err)
          if (err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
		} else {
			rej('no id')
		}
	})

export const getContact = (id) => (dispatch, getState) =>
	new Promise((resolve, reject) => {
		if (id) {
			dispatch({ type: ActionType.Contacts.GET_REQUEST, id })

			return Auth.currentSession()
				.then((session) => {
					const headerValue = `Bearer ${session.idToken.jwtToken}`

					return fetch(`${API_URL}/contact/${id}`, {
						cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
						headers: {
							'content-type': 'application/json',
							authorization: headerValue,
						},
						method: 'GET', // *GET, POST, PUT, DELETE, etc.
						mode: 'cors', // no-cors, cors, *same-origin
						redirect: 'follow', // manual, *follow, error
						referrer: 'no-referrer', // *client, no-referrer
					})
						.then((res) =>
							res.json().then((data) => {
								if (!res.ok) {
									return { notOk: true, ...data }
								}
								return data
							}),
						)
						.then((payload) => {
							if (payload && payload.notOk) {
								console.log('this one right here:', id)
								dispatch({
									type: ActionType.Data.READ_FAILURE,
									payload,
									entityType: 'contact',
									notOk: true,
								})
								reject(payload)
								return
							}

							dispatch({
								type: ActionType.Contacts.GET_SUCCESS,
								payload,
								id,
							})
							resolve(payload)
						})
						.catch((error) => {
							dispatch({
								type: ActionType.Data.READ_FAILURE,
								payload: error,
								entityType: 'contact',
								notOk: true,
							})
							reject(error)
						})
				})
				.catch((err) => {
					console.log(err)
					if (err.code === 'UserNotFoundException') {
						window.localStorage.clear()
						window.location.reload(true)
					}
				})
		} else {
			reject('no id')
		}
	})

export const getContactsWithEmails = () => (dispatch, getState) =>
	new Promise((resolve, reject) => {
		dispatch({ type: ActionType.Contacts.GET_ALL_WITH_EMAILS_REQUEST })

		return Auth.currentSession()
			.then((session) => {
				const headerValue = `Bearer ${session.idToken.jwtToken}`

				return fetch(`${API_URL}/contact`, {
					mode: 'cors',
					headers: {
						authorization: headerValue,
					},
				})
					.then((res) =>
						res.json().then((data) => {
							if (!res.ok) {
								return { notOk: true, ...data }
							}
							return data
						}),
					)
					.then(
						(payload) => {
							if (payload && payload.notOk) {
								dispatch({
									type: ActionType.Data.LIST_FAILURE,
									payload,
									entityType: 'contact',
									notOk: true,
								})
								reject(payload)
								return
							}

							dispatch({
								type: ActionType.Contacts.GET_ALL_WITH_EMAILS_SUCCESS,
								payload,
							})
							resolve(payload)
						},
						// Note: it's important to handle errors here
						// instead of a catch() block so that we don't swallow
						// exceptions from actual bugs in components.
						(error) => {
							dispatch({
								type: ActionType.Data.LIST_FAILURE,
								payload: error,
								entityType: 'contact',
							})
							reject(error)
						},
					)
			})
			.catch((err) => {
				console.log(err)
				if (err.code === 'UserNotFoundException') {
					window.localStorage.clear()
					window.location.reload(true)
				}
			})
	})

export const createContact = (contact) => (dispatch, getState) =>
	new Promise((resolve, reject) => {
		// console.log('create contact')
		dispatch({
			type: ActionType.Contacts.CREATE_REQUEST,
			payload: contact,
		})

		// console.log('line 143')
		const schemas = getState().contacts.schema
		const schema = schemas && schemas.POST
		// console.log(schema)
		// console.log('line 146')

		const postHelper = (schema) => {
			const ajv = new AJV({ verbose: true, allErrors: true })
			const valid = ajv
				.addSchema(schema, 'postContactSchema')
				.validate('postContactSchema', contact)

			if (!valid) {
				dispatch({
					type: ActionType.Contacts.VALIDATION_FAILURE,
					payload: valid,
					errors: ajv.errors,
					errorsText: ajv.errorsText(),
				})
				return valid
			}

			return Auth.currentSession()
				.then((session) => {
					dispatch({ type: ActionType.Contacts.VALIDATION_SUCCESS })
					const headerValue = `Bearer ${session.idToken.jwtToken}`

					return fetch(`${API_URL}/contact`, {
						body: JSON.stringify(contact), // must match 'Content-Type' header
						cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
						headers: {
							'content-type': 'application/json',
							authorization: headerValue,
						},
						method: 'POST', // *GET, POST, PUT, DELETE, etc.
						mode: 'cors', // no-cors, cors, *same-origin
						redirect: 'follow', // manual, *follow, error
						referrer: 'no-referrer', // *client, no-referrer
					})
						.then((res) =>
							res.json().then((data) => {
								if (!res.ok) {
									return { notOk: true, ...data }
								}
								return data
							}),
						)
						.then((payload) => {
							if (payload && payload.notOk) {
								dispatch({
									type: ActionType.Data.CREATE_FAILURE,
									payload,
									entityType: 'contact',
									notOk: true,
								})
								reject(payload)
								return
							}

							dispatch({
								type: ActionType.Contacts.CREATE_SUCCESS,
								payload,
							})
							resolve(payload)
						})
						.catch((error) => {
							dispatch({
								type: ActionType.Data.CREATE_FAILURE,
								payload: error,
								entityType: 'contact',
							})
							reject(error)
						})
				})
				.catch((err) => {
					console.log(err)
					if (err.code === 'UserNotFoundException') {
						window.localStorage.clear()
						window.location.reload(true)
					}
				})
		}

		if (schema) {
			// console.log('hits if')
			return postHelper(schema)
		} else {
			// console.log('hits else')
			return dispatch(getContactSchema('POST')).then((schema) =>
				postHelper(schema),
			)
		}
	})

export const updateContact = (contact) => (dispatch, getState) =>
	new Promise((resolve, reject) => {
		// console.log(contact)
		dispatch({
			type: ActionType.Contacts.UPDATE_REQUEST,
			payload: contact,
		})
		// console.log(getState().contacts.schema)
		// debugger
		const schemas = getState().contacts.schema
		const schema = schemas && schemas.PUT

		const putHelper = (schema) => {
			// console.log('putHelper')
			const ajv = new AJV({ verbose: true, allErrors: true })
			const valid = ajv
				.addSchema(schema, 'putContactSchema')
				.validate('putContactSchema', contact)

			if (!valid) {
				dispatch({
					type: ActionType.Contacts.VALIDATION_FAILURE,
					payload: valid,
					errors: ajv.errors,
					errorsText: ajv.errorsText(),
				})
				return valid
			}

			return Auth.currentSession()
				.then((session) => {
					dispatch({ type: ActionType.Contacts.VALIDATION_SUCCESS })
					const headerValue = `Bearer ${session.idToken.jwtToken}`

					return fetch(`${API_URL}/contact/${contact.id}`, {
						body: JSON.stringify(contact), // must match 'Content-Type' header
						cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
						headers: {
							'content-type': 'application/json',
							authorization: headerValue,
						},
						method: 'PUT', // *GET, POST, PUT, DELETE, etc.
						mode: 'cors', // no-cors, cors, *same-origin
						redirect: 'follow', // manual, *follow, error
						referrer: 'no-referrer', // *client, no-referrer
					})
						.then((res) =>
							res.json().then((data) => {
								if (!res.ok) {
									return { notOk: true, ...data }
								}
								return data
							}),
						)
						.then((payload) => {
							if (payload && payload.notOk) {
								dispatch({
									type: ActionType.Data.UPDATE_FAILURE,
									payload,
									entityType: 'contact',
									notOk: true,
								})
								reject(payload)
								return
							}

							dispatch({
								type: ActionType.Contacts.UPDATE_SUCCESS,
								payload,
							})
							resolve(payload)
						})
						.catch((error) => {
							dispatch({
								type: ActionType.Data.UPDATE_FAILURE,
								payload: error,
								entityType: 'contact',
							})
							reject(error)
						})
				})
				.catch((err) => {
					console.log(err)
					if (err.code === 'UserNotFoundException') {
						window.localStorage.clear()
						window.location.reload(true)
					}
				})
		}

		if (schema) {
			console.log('hits if')
			return putHelper(schema)
		} else {
			console.log('hits else')
			return dispatch(getContactSchema('PUT')).then((schema) =>
				putHelper(schema),
			)
		}
	})

export const deleteContact = (id) => (dispatch, getState) => {
	dispatch({ type: ActionType.Contacts.DELETE_REQUEST, payload: id })

	return Auth.currentSession()
		.then((session) => {
			const headerValue = `Bearer ${session.idToken.jwtToken}`

			return fetch(`${API_URL}/contact/${id}`, {
				cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
				headers: {
					'content-type': 'application/json',
					authorization: headerValue,
				},
				method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
				mode: 'cors', // no-cors, cors, *same-origin
				redirect: 'follow', // manual, *follow, error
				referrer: 'no-referrer', // *client, no-referrer
			})
				.then((res) =>
					res.json().then((data) => {
						if (!res.ok) {
							return { notOk: true, ...data }
						}
						return data
					}),
				)
				.then((payload) => {
					if (payload && payload.notOk) {
						dispatch({
							type: ActionType.Data.DELETE_FAILURE,
							payload,
							entityType: 'contact',
							notOk: true,
						})
						return
					}

					dispatch({
						type: ActionType.Contacts.DELETE_SUCCESS,
						payload,
						id,
					})
				})
				.catch((error) =>
					dispatch({
						type: ActionType.Contacts.DELETE_FAILURE,
						payload: error,
						entityType: 'contact',
					}),
				)
		})
		.catch((err) => {
			console.log(err)
			if (err.code === 'UserNotFoundException') {
				window.localStorage.clear()
				window.location.reload(true)
			}
		})
}

export const getCustomAttributes = () => (dispatch, getState) => {
	dispatch({ type: ActionType.Contacts.GET_CUSTOM_ATTRIBUTES_REQUEST })

	return Auth.currentSession()
		.then((session) => {
			const headerValue = `Bearer ${session.idToken.jwtToken}`

			return fetch(`${API_URL}/attributes/contacts`, {
				cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
				headers: {
					'content-type': 'application/json',
					authorization: headerValue,
				},
				method: 'GET', // *GET, POST, PUT, DELETE, etc.
				mode: 'cors', // no-cors, cors, *same-origin
				redirect: 'follow', // manual, *follow, error
				referrer: 'no-referrer', // *client, no-referrer
			})
				.then((res) =>
					res.json().then((data) => {
						if (!res.ok) {
							return { notOk: true, ...data }
						}
						return data
					}),
				)
				.then((payload) =>
					payload && payload.notOk
						? dispatch({
							type: ActionType.Data.LIST_FAILURE,
							payload,
							entityType: 'customattributes',
							notOk: true,
						})
						: dispatch({
							type: ActionType.Contacts.GET_CUSTOM_ATTRIBUTES_SUCCESS,
							payload,
						}),
				)
				.catch((error) =>
					dispatch({
						type: ActionType.Data.LIST_FAILURE,
						payload: error,
						entityType: 'customattributes',
					}),
				)
		})
		.catch((err) => {
			console.log(err)
			if (err.code === 'UserNotFoundException') {
				window.localStorage.clear()
				window.location.reload(true)
			}
		})
}

export const bulkUpload =
	(files, groupID = undefined, assignmentPoolID = undefined) =>
		(dispatch, getState) => {
			dispatch({ type: ActionType.Contacts.BULK_UPLOAD_REQUEST });

			return Auth.currentSession()
				.then((session) => {
					const headerValue = `Bearer ${session.idToken.jwtToken}`;

					const body = new FormData();
					body.append('contacts', files[0]);
					if (groupID) body.append('contactgroup_id', groupID);
					if (assignmentPoolID) body.append('assignmentpool_id', assignmentPoolID);

					if (body.get('contacts')) {
						return fetch(`${API_URL}/upload/contacts/csv`, {
							body,
							cache: 'no-cache',
							headers: {
								authorization: headerValue,
							},
							method: 'POST',
							mode: 'cors',
							redirect: 'follow',
							referrer: 'no-referrer',
						})
							.then((res) =>
								res.json().then((data) => {
									if (!res.ok) {
										return { notOk: true, ...data }
									}
									return data
								}),
							)
							.then((payload) => {
								const poll = () => {
									const endTime = Number(new Date()) + 6000000

									const checkCondition = (resolve, reject) => {
										return fetch(`${API_URL}${payload.status_check_endpoint}`, {
											cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
											headers: {
												authorization: headerValue,
											},
											method: 'GET', // *GET, POST, PUT, DELETE, etc.
											mode: 'cors', // no-cors, cors, *same-origin
											redirect: 'follow', // manual, *follow, error
											referrer: 'no-referrer', // *client, no-referrer
										})
											.then((res) =>
												res.json().then((data) => {
													if (!res.ok) {
														return { notOk: true, ...data }
													}
													return data
												}),
											)
											.then((statusPayload) => {
												dispatch({
													type: ActionType.Contacts.BULK_UPLOAD_PROGRESS,
													payload: statusPayload,
												})
												if (
													statusPayload &&
													statusPayload.status &&
													statusPayload.status.job_status.includes('complete')
												) {
													resolve(statusPayload)
												} else if (Number(new Date()) < endTime) {
													setTimeout(checkCondition, 2500, resolve, reject)
												} else {
													reject(statusPayload)
												}
											})
									}
									return new Promise(checkCondition)
								}

								poll()
									.then((newPayload) =>
										dispatch({
											type: ActionType.Contacts.BULK_UPLOAD_SUCCESS,
											payload: newPayload,
										}),
									)
									.then(() => dispatch(getContactsWithEmails()))
									.then(() => { })
									.catch((error) =>
										dispatch({
											type: ActionType.Contacts.BULK_UPLOAD_FAILURE,
											payload: error,
										}),
									)
								// {
								//   status: {
								//     entity_type: "Contact",
								//     error_count: 0,
								//     file_name: "contactcustom.csv",
								//     job_status: "processing_started",
								//     source_prefix: "2018102661035",
								//     success_count: 0,
								//     upload_id: "1540534235257260367",
								//   },
								//   status_check_endpoint: "/upload/status/contacts/1540534235257260367",
								//   upload_id: "1540534235257260367"
								// }	
							})
							.catch((error) =>
								dispatch({
									type: ActionType.Contacts.BULK_UPLOAD_FAILURE,
									payload: error,
								})
							);
					}
				})
				.catch((err) => {
					console.log(err);
					if (err.code === 'UserNotFoundException') {
						window.localStorage.clear();
						window.location.reload(true);
					}
				});
		};

export const createOrUpdateContact =
  propertyOverrides => (dispatch, getState) => {
    const selector = contactFieldsWithoutColorsSelector(getState())
    console.log(selector)
    const contactID = getState().addOrEditContact.contactID

    dispatch({
      type: 'create or update contact attempt',
      selector,
      contactID,
    })

    if (contactID === 'new') {
      return dispatch(createContact({ ...selector, ...propertyOverrides }))
    } else {
      return dispatch(updateContact({ ...selector, ...propertyOverrides }))
    }
  }

export const toggleOptOut =
	(contactID, type, id, index, toggleString) => (dispatch, getState) =>
		new Promise((resolve, reject) => {
			const methodType = type === 'phones' ? 'phone' : 'email'

			dispatch({
				type: ActionType.Contacts.TOGGLE_OPT_OUT_REQUEST,
				contactID,
				id,
				methodType,
				index,
			})

			return Auth.currentSession()
				.then((session) => {
					const headerValue = `Bearer ${session.idToken.jwtToken}`

					return fetch(
						`${API_URL}/contact/${contactID}/${methodType}/${id}/${toggleString}`,
						{
							cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
							headers: {
								'content-type': 'application/json',
								authorization: headerValue,
							},
							method: 'PUT', // *GET, POST, PUT, DELETE, etc.
							mode: 'cors', // no-cors, cors, *same-origin
							redirect: 'follow', // manual, *follow, error
							referrer: 'no-referrer', // *client, no-referrer
						},
					)
						.then((res) =>
							res.json().then((data) => {
								if (!res.ok) {
									return { notOk: true, ...data }
								}
								return data
							}),
						)
						.then((payload) => {
							if (payload && payload.notOk) {
								dispatch({
									type: ActionType.Data.UPDATE_FAILURE,
									payload,
									entityType: 'contact',
									notOk: true,
								})
								reject(payload)
								return
							}

							dispatch({
								type: ActionType.Contacts.TOGGLE_OPT_OUT_SUCCESS,
								payload,
								contactID,
								id,
								methodType,
								index,
							})
							resolve(payload)
						})
						.catch((error) => {
							dispatch({
								type: ActionType.Data.UPDATE_FAILURE,
								payload: error,
								entityType: 'contact',
								contactID,
								id,
								methodType,
								index,
							})
							reject(error)
						})
				})
				.catch((err) => {
					console.log(err)
					if (err.code === 'UserNotFoundException') {
						window.localStorage.clear()
						window.location.reload(true)
					}
				})
		})

export const getContactSchema = (schemaType) => (dispatch, getState) => {
	// TODO: figure out how to handle errors with this
	dispatch({ type: ActionType.Contacts.SCHEMA_REQUEST })

	const url = {
		POST: `${API_URL}/schema/${service}/${schemaType}/request/`,
		PUT: `${API_URL}/schema/${service}/${service}Id/${schemaType}/request/`,
	}
	return new Promise((resolve, reject) => {
		return fetch(url[schemaType], {
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			headers: {
				'content-type': 'application/json',
				dnt: 0,
			},
			method: 'GET', // *GET, POST, PUT, DELETE, etc.
			mode: 'cors', // no-cors, cors, *same-origin
			redirect: 'follow', // manual, *follow, error
			referrer: 'no-referrer', // *client, no-referrer
		})
			.then((res) =>
				res.json().then((data) => {
					if (!res.ok) {
						return { notOk: true, ...data }
					}
					return data
				}),
			)
			.then(
				(schema) => {
					dispatch({
						type: ActionType.Contacts.SCHEMA_SUCCESS,
						payload: { schema, schemaType },
					})
					resolve(schema)
				},
				(error) => {
					dispatch({
						type: ActionType.Contacts.SCHEMA_FAILURE,
						payload: error,
					})
					reject(error)
				},
			)
	})
}
